import { post } from '../axios'

// 模板上传
export function cms_template_upload_post(map, option) {
  return post(
    `${process.env.VUE_APP_CMS}/cms/template/upload`,
    map,
    option
  ).then(response => response)
}

// 保存模板
export function cms_template_add_post(map, option) {
  return post(`${process.env.VUE_APP_CMS}/cms/template/add`, map, option).then(
    response => response
  )
}

// 模板列表查询
export function cms_template_list_post(map, option) {
  return post(`${process.env.VUE_APP_CMS}/cms/template/list`, map, option).then(
    response => response
  )
}

// 模板删除
export function cms_template_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_CMS}/cms/template/delete`,
    map,
    option
  ).then(response => response)
}

// 素材上传
export function cms_material_upload_post(map, option) {
  return post(
    `${process.env.VUE_APP_CMS}/cms/material/upload`,
    map,
    option
  ).then(response => response)
}

// 保存素材
export function cms_material_add_post(map, option) {
  return post(`${process.env.VUE_APP_CMS}/cms/material/add`, map, option).then(
    response => response
  )
}

// 素材列表查询
export function cms_material_list_post(map, option) {
  return post(`${process.env.VUE_APP_CMS}/cms/material/list`, map, option).then(
    response => response
  )
}

// 更新模板
export function cms_template_update_post(map, option) {
  return post(
    `${process.env.VUE_APP_CMS}/cms/template/update`,
    map,
    option
  ).then(response => response)
}

// 素材删除
export function cms_material_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_CMS}/cms/material/delete`,
    map,
    option
  ).then(response => response)
}

// Collection类目列表
export function cms_collect_listing_post(map, option) {
  return post(
    `${process.env.VUE_APP_CMS}/cms/collect/listing`,
    map,
    option
  ).then(response => response)
}

// Collection商品详情
export function cms_collect_detail_product_more_collectId_post(map, option) {
  return post(
    `${process.env.VUE_APP_CMS}/cms/collect/detail/product/more/${map.collectId}`,
    map,
    option
  ).then(response => response)
}

// Product产品列表查询
export function cms_product_listing_post(map, option) {
  return post(
    `${process.env.VUE_APP_CMS}/cms/product/listing`,
    map,
    option
  ).then(response => response)
}

// skc商品查询
export function cms_skc_listing_post(map, option) {
  return post(`${process.env.VUE_APP_CMS}/cms/skc/listing`, map, option).then(
    response => response
  )
}

// 根据模板id查询模板信息
export function cms_template_get_id_post(map, option) {
  return post(
    `${process.env.VUE_APP_CMS}/cms/template/get/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 根据英文名称查询模板
export function cms_template_getByEnName_post(map, option) {
  return post(
    `${process.env.VUE_APP_CMS}/cms/template/getByEnName`,
    map,
    option
  ).then(response => response)
}
